import CustomTable from '../../../../../components/table/CustomTable';
import {permissionObj} from '../../../../../Helpers/permission';
import React from 'react';
import DisplayView from '../../../../../components/DisplayView';
import SearchSimple from '../../../../../components/SearchSimples/SearchSimple';
import CustomButtonLink from '../../../../../components/buttons/CustomButtonLink';
import {getViewTypeByName} from '../../../../../enums/ViewType';
import {SuppliersTableApp} from "../../Funtionality/SupplierTab/SuppliersTableApp";

/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
const SuppliersTable = (props) => {

    const {
        view,
        setView,
        contractorId,
        selectedList,
        isAllChecked,
        searchElement,
        setSearchElement,
        setSearch,
        setSimpleSearch,
        supplierId,
        finalArray,
        setModified,
        modified,
        setBodyForExport,
        setCriteria,
        setIsAllChecked,
        setSelectedList,
        handleCreate
    } = props;

    const {
        t,
        DEV,
        permission,
        tableId,
        searchId,
        thead,
        tbody,
        option,
        pagination,
        getActionsButtons,
        handleCheckboxChange,
        handleDeleteAll,
        setResults,
        page,
        rowsPerPage,
        deletePermission
    } = SuppliersTableApp({
        view,
        supplierId,
        contractorId,
        searchElement,
        finalArray,
        setModified,
        modified,
        setBodyForExport,
        setCriteria,
        setIsAllChecked,
        setSelectedList
    });

    return (
        <>
            <div className={"d-flex"}>
                <DisplayView view={view} setView={setView} left={0} />
                <div className={"ml-2 w-100"}>
                    <SearchSimple
                        id={"txt_st_search_suppliers"}
                        setBodyForExport={setBodyForExport}
                        setSearchResults={setResults}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        contractorId={contractorId}
                        supplierId={supplierId}
                        viewType={getViewTypeByName(view)}
                    />
                </div>
            </div>

            <CustomTable
                tableId={tableId}
                searchId={searchId}
                checkbox={deletePermission}
                checkboxTitle={"de_/_select_all"}
                isAllChecked={isAllChecked}
                onChangeCheckbox={handleDeleteAll}
                thead={thead}
                tbody={tbody}
                columnActions={true}
                getActionsButtons={getActionsButtons}
                handleCheckboxChange={handleCheckboxChange}
                selectedList={selectedList}
                childrenNotInformation={tbody?.data?.length === 0 ? <>
                        <div className={"warning-text"}>
                            <p>{t("you_haven_not_created_any_supplier_yet")}</p>
                        </div>
                        { (DEV || permission?.includes(permissionObj?.WEB_SUPPLIER_CREATE)) &&
                        <CustomButtonLink splitName={false} id={'btn_st_create'} card={true}
                                          onClick={handleCreate}
                                          name={'create_new_supplier'}/>
                        } </>
                    : undefined
                }
            />

            { pagination() }
        </>
    );

}

export default SuppliersTable
